import { ProductPageLayout } from '../components/ProductPageLayout';

export function VirtualTryOnWorkflowPage() {
    return <ProductPageLayout productId="virtual-try-on-workflow" />;
}
